// "Open overview" chip(s) for a member project: renders nothing unless the project
// belongs to an overview the signed-in user may open. The overview list is fetched
// once per minute for the whole app, not once per mount.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchOverviews } from './overviewApi';
import { useServerPermission } from '../../utils/serverPermissions';
import { rememberSource, sourceId } from '../SafetyOverview/safetyOverviewApi';

let cache = { at: 0, promise: null };
const loadOnce = () => {
  if (!cache.promise || Date.now() - cache.at > 60000) {
    cache = { at: Date.now(), promise: fetchOverviews().then((d) => d.overviews || []).catch(() => []) };
  }
  return cache.promise;
};

export default function OverviewLinks({ projectId }) {
  const [mine, setMine] = useState([]);
  const { allowed } = useServerPermission('view_safety_overview');
  useEffect(() => {
    let live = true;
    const id = Number(projectId);
    if (!id) { setMine([]); return undefined; }
    loadOnce().then((all) => { if (live) setMine(all.filter((o) => o.projects.some((p) => p.id === id))); });
    return () => { live = false; };
  }, [projectId]);
  if (!allowed || !mine.length) return null;
  return (
    <span className="overview-links" data-testid="overview-links">
      {mine.map((o) => (
        <Link key={o.id} to="/safety-dashboard" className="overview-link-chip"
          onClick={() => rememberSource(sourceId('ov', o.id))}
          title={`This project is part of the overview "${o.name}"`}
          style={{ display: 'inline-block', marginLeft: '0.5rem', padding: '0.1rem 0.55rem', border: '1px solid #334155',
            borderRadius: '999px', fontSize: '0.75rem', color: '#93c5fd', textDecoration: 'none', whiteSpace: 'nowrap' }}>
          Open overview · {o.name}
        </Link>
      ))}
    </span>
  );
}
